<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <ul class="breadcrumb breadcrumb-style ">
            <li class="breadcrumb-item">
              <h4 class="page-title">Product Price Trace</h4>
            </li>

          </ul>
        </div>
      </div>
    </div>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Product</th>
          <th>Start Date</th>
          <th> Started By</th>
          <th> Old Quantity</th>
          <th> New Quantity</th>
          <th> Old Mrp</th>
          <th> New Mrp</th>
          <th> Old Gst</th>
          <th> New Gst</th>
          <th> Old snf</th>
          <th> New snf</th>
          <th> Old fat</th>
          <th> New fat</th>
          <th>End Date</th>
          <th> Ended By</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let trace of dataSource">
          <th>{{trace['product_name']}}</th>
          <td>{{trace['start_date'] | date:'medium'}}</td>
          <td>{{trace['start_by']}}</td>
          <td>{{trace['old_quantity']}}</td>
          <td
            [style.color]=" trace.old_quantity != trace.new_quantity &&  trace.old_quantity != '-' ?  'red' : 'black'">
            {{trace['new_quantity']}}</td>
          <td>{{trace['old_mrp']}}</td>
          <td [style.color]=" trace.old_mrp != trace.new_mrp ?  'red' : 'black'">{{trace['new_mrp']}}</td>
          <td>{{trace['old_gst_percent']}}</td>
          <td [style.color]=" trace.old_gst_percent != trace.new_gst_percent ?  'red' : 'black'">
            {{trace['new_gst_percent']}}</td>
          <td>{{trace['old_snf']}}</td>
          <td [style.color]=" trace.old_snf != trace.new_snf ?  'red' : 'black'">{{trace['new_snf']}}</td>
          <td>{{trace['old_fat']}}</td>
          <td [style.color]=" trace.old_fat != trace.new_fat ?  'red' : 'black'">{{trace['new_fat']}}</td>
          <td *ngIf="trace['end_date'] != '-'">{{trace['end_date'] | date:'medium'}}</td>
          <td *ngIf="trace['end_date'] == '-'">{{trace['end_date']}}</td>
          <td>{{trace['ended_by']}}</td>
        </tr>
      </tbody>
    </table>

  </div>
</section>
